import { render, staticRenderFns } from "./HeaderRoundedCtrl.vue?vue&type=template&id=52108cc6&"
import script from "./HeaderRoundedCtrl.vue?vue&type=script&lang=ts&"
export * from "./HeaderRoundedCtrl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports